"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.followUpSubMenu = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
const followUpSubMenu = exports.followUpSubMenu = [{
  path: '/follow-ups/list/:leadId(\\d+)',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/follow-ups/list.vue'))),
  name: 'Follow-up',
  meta: {
    title: 'leadManagement.followup.title',
    noCache: true,
    icon: 'guide',
    hidden: true
  }
}, {
  path: '/follow-ups/add/:leadId(\\d+)',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/follow-ups/manage.vue'))),
  name: 'Add Followup',
  props: {
    isEdit: false
  },
  meta: {
    title: 'leadManagement.followup.manage',
    noCache: true,
    activeMenu: '/leads/list/:leadId(\\d+)',
    hidden: true
  }
}, {
  path: '/follow-ups/edit/:id(\\d+)',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/follow-ups/manage.vue'))),
  name: 'Edit Followup',
  props: {
    isEdit: true
  },
  meta: {
    title: 'leadManagement.followup.manage',
    noCache: true,
    activeMenu: '/follow-ups/list/:leadId(\\d+)',
    hidden: true
  }
}];